module.exports = __webpack_public_path__ + "static/redact-cfc3e3815d99553d202ef4635e690fc0.mp4";